// Edits a maintenance option's controls make (#515). A change to the option's choices is applied later,
// to the choices as stored (options.ts saveScope), so anything read from the event must be read now:
// by then React has put a controlled drop-down back to the value it was drawn with, and reading
// `e.target.value` at that point saves the old choice (the Schedule of Work bug, 23 Oct 2026). Pure.
import { setYearWork, type OptionScope, type YearWork } from '@higgins/m2q-pricing';

type OnScope = (change: (scope: OptionScope) => OptionScope) => void | Promise<void>;

/** A Schedule of Work drop-down's change: the year's work is read from the event before the change is queued. */
export const yearWorkChange =
  (onScope: OnScope, areaId: string, year: number) =>
  (event: { target: { value: string } }): void => {
    const work = event.target.value as YearWork;
    void onScope((scope) => setYearWork(scope, areaId, year, work));
  };
